
import axios from "axios"
import { toast } from "react-toastify";
const handleupload = ({ meta, file }, status,name,fileUploadFlag,setValue,trigger,setUploadedFile,setIsEdit,setLoading) => {
    if (status == 'done') {
        const formData = new FormData()
        formData.append('profile', file)
        setLoading && setLoading(true)
            axios.put(`${process.env.REACT_APP_SERVER_URL}/api/users/uploadImage`, formData, {
            }).then(res => {
                setValue && setValue(name, res.data.msg)
                setIsEdit(false)
                setLoading && setLoading(false)
                setUploadedFile(res.data.msg)
                trigger && trigger(name);
                toast.success('File Uploaded Successfully');
            }).catch(err => {
                setLoading && setLoading(false)
            })
        
    } else if (status == 'removed') {
        setLoading && setLoading(false)
        setValue && setValue(name,"")
    }
}

export default handleupload